import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { TextInputControl } from 'components/_basic/Form/TextInput';

import { concatWithDot } from 'helpers/string';

import { WORK_EXPERIENCE_NAMES } from '../../utils/form';

export const WorkExperience: FC<{ name: string; disabled?: boolean }> = memo(({ name, disabled = false }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextInputControl
          control={control}
          id={concatWithDot(name, WORK_EXPERIENCE_NAMES.EMPLOYER)}
          name={concatWithDot(name, WORK_EXPERIENCE_NAMES.EMPLOYER)}
          label={t('management.partners.employer')}
          disabled={disabled}
          maxLength={150}
        />
      </Grid>
      <Grid item xs={6}>
        <TextInputControl
          control={control}
          id={concatWithDot(name, WORK_EXPERIENCE_NAMES.POSITION)}
          name={concatWithDot(name, WORK_EXPERIENCE_NAMES.POSITION)}
          label={t('management.partners.position')}
          disabled={disabled}
          maxLength={150}
        />
      </Grid>
    </Grid>
  );
});
